import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SESSION_STORAGE_ONBOARDING_REQUEST_NUMBER_VERIFIED } from "../../utils/constants";
import { Button, Checkbox, TermsOfUseContent } from "../../components";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { setRequestAcceptedTerms } from "../../redux/slices/OnBoardingSlice";

import { useSelector } from "react-redux";
const TermsAndConditions = ({ showCheckbox = true }: { showCheckbox?: boolean }) => {
  const [tcAccepted, setTcAccepted] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch<AppDispatch>();
  const { loading } = useSelector((state: RootState) => state.onBoarding);
  const guestToken = sessionStorage.getItem(SESSION_STORAGE_ONBOARDING_REQUEST_NUMBER_VERIFIED);
  const guestData = JSON.parse(guestToken || "{}");
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (tcAccepted) {
      dispatch(setRequestAcceptedTerms({ guestToken: guestData.GuestToken, acceptedTerms: tcAccepted })).then(() => {
        navigate("/guest/view-request");
      });
    } else {
      setError("You must accept the terms before you can submit.");
    }
  };

  return (
    <>
      <TermsOfUseContent />
      <div className="p-4">
        {error ? <span className="text-red-500">{error}</span> : null}
        {showCheckbox && guestData.GuestToken ? (
          <div className="flex flex-col gap-3">
            <label className="flex justify-start items-center">
              <Checkbox
                checked={tcAccepted}
                onChange={() => {
                  setTcAccepted(!tcAccepted);
                  setError("");
                }}
                label=""
              />
              <span className="text-sm text-slate-500 ml-2">I accept the Terms of Use</span>
            </label>
            <div className="w-fit">
              <Button text={"Submit"} onClick={() => handleSubmit()} variant={loading ? "loading" : "Primary"} />
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default TermsAndConditions;
